













import { Component, Vue } from 'vue-property-decorator';
import CollectionList from '@/components/collections/CollectionList.vue';
import TitleContainer from '@/components/common/TitleContainer.vue';
import { MetaInfo } from 'vue-meta/types/vue-meta';
import seoDefault from '@/utils/seo-default';

@Component({
  components: {
    TitleContainer,
    CollectionList,
  },
  metaInfo(this: Collections): MetaInfo {
    return {
      title: 'Your Collections |',
      meta: [
        ...seoDefault({
          title: 'Your Collections | Mysoalan',
          description:
            'A collection is a place where you can collect any question from the question bank. You can mix any question you want in it, from the easiest question to the hardest question.',
        }),
      ],
    };
  },
})
export default class Collections extends Vue {
  mainTitle = [
    {
      type: 'highlight',
      value: 'Your',
    },
    {
      type: 'normal',
      value: 'collections',
    },
  ];

  mainP = `A collection is a place where you can collect any question from the
          question bank. You can mix any question you want in it, from the
          easiest question to the hardest question. You also can generate PDF
          for each collection.`;
}
